export default "__VITE_ASSET__DJNocOYL__"